import { Arrow } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { DAY_FIRST_DATE_FORMAT } from 'screens/Rostering/utils.datetime'
import styled from 'styled-components'

export type DateRangeProps = {
  fromDate: string
  toDate: string
  dateFormat?: string
}

const DateRange = ({ fromDate, toDate, dateFormat }: DateRangeProps) => {
  dateFormat = dateFormat ?? DAY_FIRST_DATE_FORMAT

  const { t } = useTranslation()

  return (
    <DateRangeContainer>
      <StartDate>
        <Title>{t('SELECTED_DATE')}</Title>
        <Description>{dayjs(fromDate).format(dateFormat)}</Description>
      </StartDate>
      <Arrow direction="right" size={16} />
      <EndDate>
        <Title>{t('TO_DATE')}</Title>
        <Description>{dayjs(toDate).format(dateFormat)}</Description>
      </EndDate>
    </DateRangeContainer>
  )
}

export default DateRange

const DateRangeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 350px;
  margin-bottom: 24px;
`

const StartDate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const EndDate = StartDate

const Title = styled(Text)`
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
`

const Description = styled(Text)`
  font-size: 16px;
  line-height: 24px;
`
